<script setup lang="ts">
import Datepicker from '~/components/ui/Datepicker.vue';
//import { Menu, type MenuItem } from '~/components/ui/Menu';
import { ref, computed } from 'vue';
import DxTreeView from 'devextreme-vue/tree-view';
import axios from 'axios';

const route = useRoute();
const intern = ref(false);
const { $emitter } = useNuxtApp();
const date = defineModel('date', {
    default: [new Date().setDate(1), new Date()],
});
const isOpen = defineModel('isOpen', { default: false });
const datausertreeacess = ref([]);

const currentItem = ref([]);
function toggleOpen() {
    isOpen.value = !isOpen.value;
}

const getusertreeacess = async () => {
    try {
        var windowsname = localStorage.getItem('windows_name');
        windowsname = encodeURIComponent(windowsname).replace('%20', '');
        const token = sessionStorage.getItem("temp_tok_laravel");
        const { data } = await axios.post(
            'https://api.tempton-connect.de/api/nutzer/benutzer',
            { windowsname },
            {
                headers: {
                    authorization: `Bearer ${token}`,
                },
            }
        );
        //console.log('da',data.data);
        var nlid = localStorage.getItem('NL_ID');
        if (!nlid || nlid == null || nlid == '') {
            var valNL = data.data.filter(function (item) {
                var c = item.id.toString();
                if (c.length === 6) return c;
            });
           //console.log('valNL',valNL[0].id);
            localStorage.setItem('NL_ID', valNL[0].id);
        }
        if (data.data[0] !== undefined) {
            var obj = data.data[0];
            Object.assign(obj, { isExpanded: 'true' });
            datausertreeacess.value = data.data;
        } else {
            localStorage.setItem('NL_ID', String(1));
        }
    } catch (error) {
        console.error('Error fetching user tree access:', error);
    }
};
const getusertreeacess_intern = async () => {
    try {
        const token = sessionStorage.getItem("temp_tok_laravel");
        const { data } = await axios.get(
            'https://api.tempton-connect.de/api/nutzer/organisationintern',
            {
                headers: {
                    authorization: `Bearer ${token}`,
                },
            }
        );
        var nlid_intern = localStorage.getItem('NL_ID_Intern');
        if (nlid_intern == null || nlid_intern == '') {
            var valNL = data.data.filter(function (item) {
                var c = item.id.toString();
                if (c.length === 4) return c;
            });
            //console.log('NL_ID_Intern',valNL[0].id);
            localStorage.setItem('NL_ID_Intern', valNL[0].id);
        }
        if (data.data[0] !== undefined) {
            var obj = data.data[0];
            Object.assign(obj, { isExpanded: 'true' });
            datausertreeacess.value = data.data;
        } else {
            localStorage.setItem('NL_ID_Intern', String(1));
        }
    } catch (error) {
        console.error('Error fetching user tree access:', error);
    }
};
const changeNLId = () => {
    $emitter.emit('selecttree');
};
function selectItem({ itemData }) {
    currentItem.value = itemData;
    if (intern.value == false) {
        localStorage.setItem('NL_ID', currentItem.value.id);
    } else {
        localStorage.setItem('NL_ID_Intern', currentItem.value.id);
    }
    changeNLId();
}

onMounted(async () => {
    $emitter.on('click-info', toggleOpen);
    const checkReady = () => {
        return (
            localStorage.getItem('windows_name') &&
            sessionStorage.getItem("temp_tok_laravel")
        );
    };

    const waitUntilReady = async () => {
        let retries = 0;
        while (!checkReady() && retries < 20) {
            await new Promise((resolve) => setTimeout(resolve, 300));
            retries++;
        }

        if (route.path.includes('/intern/')) {
            intern.value = true;
            getusertreeacess_intern();
        } else {
            intern.value = false;
            getusertreeacess();
        }
    };

    await waitUntilReady();
});
watch(
    () => route.path,
    (newPath) => {
        if (newPath.includes('/intern/')) {
            intern.value = true;
            getusertreeacess_intern();
        } else {
            intern.value = false;
            getusertreeacess();
        }
    },
    { immediate: true }
);
</script>

<template>
    <div
        class="sticky right-0 top-1/2 transform -translate-y-1/2 flex items-center"
        style="z-index: 1"
    >
        <button
            type="button"
            class="py-4 px-2 bg-secondary text-white text-4xl flex flex-col gap-4 max-h-fit cursor-pointer"
            @click="toggleOpen"
        >
            <i class="font-simpleicons simple-icon-organization" />
            <i class="font-simpleicons simple-icon-calendar" />
        </button>
        <div
            v-if="isOpen"
            class="relative py-8 px-6 bg-white w-[300px] h-[525px] rounded-lg border-[3px] border-secondary flex flex-col justify-between gap-4"
        >
            <!-- <div>
				<div class="relative border rounded-md shadow-sm">
					<input type="text" class="block w-full py-1.5 pl-8 pr-1.5 rounded-md border-0" placeholder="Search"
						v-model="search" />
					<div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-2">
						<i class="font-simpleicons simple-icon-magnifier" />
					</div>
				</div>
				<div class="pt-3 max-h-96 overflow-y-auto">
					<ul id="menus">
						<Menu v-for="(item, index) in filteredMenuItems" :key="index" :item="item"
							:searchQuery="search" />
					</ul>
				</div>
			</div>-->
            <div class="pt-3 max-h-96 overflow-y-auto">
                <ul id="menus">
                    <div class="mb-2">
                        <DxTreeView
                            id="simple-treeview"
                            :items="datausertreeacess"
                            data-structure="plain"
                            parent-id-expr="Parent_ID"
                            key-expr="id"
                            display-expr="Bezeichnung"
                            expanded-expr="isExpanded"
                            :search-enabled="true"
                            search-mode="contains"
                            :onItemClick="selectItem"
                        />
                    </div>
                </ul>
            </div>
          <!--  <div>
                <datepicker v-model="date" />
            </div>-->
        </div>
    </div>
</template>

<style scoped></style>
